import pdf from './../documents/sample.pdf'

export default function openPdfInNewTab(){
    window.open(pdf, '_blank', 'noopener,noreferrer')
}